import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  standardColours,
  standardTransition,
} from '../styles';
import { Button, Link } from './ui';
import rightArrow from '../images/right-arrow.svg';

const StyledImageContentCard = styled.article`
  background-color: ${standardColours.white};
  border-radius: 15px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledTextWrapper = styled.div`
  padding: 30px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

const StyledHeading = styled.h2`
  ${fontSize(18)};
  font-weight: ${fontWeights.regular};
  transition: ${standardTransition('color')};

  ${minBreakpointQuery.large`
    ${fontSize(20)};
  `}

  &:hover {
    color: ${brandColours.secondary};
  }
`;

const StyledText = styled.p`
  margin-top: 10px;

  ${minBreakpointQuery.small`
    margin-top: 15px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 20px;
  `}
`;

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  background: none;
  color: ${standardColours.black};
  transition: ${standardTransition('color')};
  padding: 0;
  font-weight: ${fontWeights.regular};
  text-align: left;
  margin-top: 20px;

  ${minBreakpointQuery.small`
    margin-top: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 30px;
  `}

  &:after {
    content: '';
    background-color: ${standardColours.black};
    transition: ${standardTransition('background')};
    mask-image: url(${rightArrow});
    font-size: 0;
    height: 12px;
    width: 12px;
    display: block;
    position: relative;
    top: 0;
    right: 0;
    flex-shrink: 0;
    margin-left: 10px;
  }

  &:hover {
    color: ${brandColours.secondary};
    background: none;

    &:after {
      background-color: ${brandColours.secondary};
    }
  }
`;

const ImageContentCard = ({ heading, text, image, link, ...props }) => (
  <StyledImageContentCard {...props}>
    <Link to={link.pageUrl}>
      <GatsbyImage
        image={image.gatsbyImageData}
        alt={image.alt}
        objectFit="cover"
      />
    </Link>
    <StyledTextWrapper>
      <StyledHeading>
        <Link to={link.pageUrl}>{heading}</Link>
      </StyledHeading>
      {text && <StyledText>{text}</StyledText>}
      <StyledButton to={link.pageUrl}>{link.text}</StyledButton>
    </StyledTextWrapper>
  </StyledImageContentCard>
);

export default ImageContentCard;
